<template>
  <div v-resize="onResize">
    <v-tabs
      v-model="tab"
      background-color="background"
      :height="EQUIPMENT_TABS_HEIGHT"
    >
      <v-tab>
        Inventaire P3
      </v-tab>
      <v-tab>
        Inventaire Technique
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="transparent-body">
      <v-tab-item>
        <loader :is-loading="P3Loading">
          <div
            class="background caption font-italic ma-2"
            v-if="!P3Inventory.length"
          >
            Pas de données liées à l'installation
          </div>
          <div
            v-else
            :style="
              `height:${height - EQUIPMENT_TABS_HEIGHT}px; overflow-y: auto;`
            "
          >
            <display-cards :items="P3Inventory" class="mx-2">
              <template v-slot:item="{ item }">
                <p3-inventory-card :item="item" :key="item.line_number" />
              </template>
            </display-cards>
          </div>
        </loader>
      </v-tab-item>
      <v-tab-item>
        <loader :is-loading="techLoading">
          <div
            class="background caption font-italic ma-2"
            v-if="!techInventoriesTree.length"
          >
            Pas de données liées à l'installation
          </div>
          <v-card
            v-else
            v-for="inventory in techInventoriesTree"
            :key="inventory.technical_inventory_code"
            class="background ma-2"
            elevation="0"
          >
            <v-card-title>
              {{ inventory.technical_inventory_code }} -
              {{ inventory.technical_inventory_name }}
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  v-for="item in inventory.children"
                  :key="item.technical_inventory_code"
                >
                  <tech-inventory-card :item="item" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </loader>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import { mapGetters } from 'vuex';
import DisplayCards from '@/components/displays/DisplayCards';
import resizable from '@/business/mixins/resizable';
import Loader from '@/components/widgets/Loader';
import { EQUIPMENT_TABS_HEIGHT } from '@/pages/FRI/summaryPropertySheet.styles';
import P3InventoryCard from './P3InventoryCard';
import TechInventoryCard from './TechInventoryCard';

function formatInventory(array, parent) {
  return {
    ...parent,
    children: array
      .filter(
        (el) =>
          el.technical_inventory_parent === parent.technical_inventory_code
      )
      .map((el) => formatInventory(array, el)),
  };
}

export default {
  name: 'EquipmentTab',
  components: {
    P3InventoryCard,
    TechInventoryCard,
    DisplayCards,
    Loader,
  },
  mixins: [resizable],
  props: {
    height: {
      type: Number,
      required: true,
    },
  },
  data: () => ({ tab: null, EQUIPMENT_TABS_HEIGHT }),
  computed: {
    ...mapGetters({
      P3Inventory: 'properties_360/warrenty_inventory/items',
      P3Loading: 'properties_360/warrenty_inventory/isLoadingItems',
      techInventories: 'properties_360/technical_inventories/items',
      techLoading: 'properties_360/technical_inventories/isLoadingItems',
    }),
    techInventoriesTree() {
      return this.techInventories
        .filter((el) => el.level === 'I')
        .map((el) => formatInventory(this.techInventories, el));
    },
  },
  methods: {
    generateMessage,
  },
};
</script>

<style scoped>
.transparent-body {
  background: transparent;
}
</style>
